// extracted by mini-css-extract-plugin
module.exports = {"container":"pYbW68VMD5mGsx_sPxvip","heading":"_3b6uuu7lmVvaJD9v0K0ygN","related":"_1g-jGN6zagtH1uaNBZ1y3V","unit":"_3ES3SU6xYH4MBSWfED2i5l"};